import React from "react";
import image1 from "../../../images/blog/blog-01.jpg";
import image2 from "../../../images/blog/blog-02.jpg";
import image3 from "../../../images/blog/blog-03.jpg";
import image4 from "../../../images/blog/blog-04.jpg";
import BlogItem from "./BlogItem";

const blogData = [
  {
    id: 1,
    image: image1,
    title: "Getting Started with 42 School: A Student's Experience",
    description:
      "My journey through the 42 School program, the peer-led learning model, and how it shaped my approach to coding and problem-solving.",
    link: "/blog/1",
  },
  {
    id: 2,
    image: image2,
    title: "Debugging Tips from 42 Core Curriculum",
    description:
      "Essential debugging techniques and tools I've learned at 42 School. From GDB to memory debugging, strategies that work.",
    link: "/blog/2",
  },
  {
    id: 3,
    image: image3,
    title: "Building Responsive Web Apps with React and Tailwind CSS",
    description:
      "A guide to creating modern, responsive web applications. Best practices, component patterns, and performance optimization tips.",
    link: "/blog/3",
  },
  {
    id: 4,
    image: image4,
    title: "Full Stack Development: From Backend to Frontend",
    description:
      "Insights on building complete web solutions. Integrating databases, APIs, and frontend frameworks for seamless user experiences.",
    link: "/blog/4",
  },
];

const Blog = () => {
  return (
    <section className="pb-10">
      <div className="flex flex-wrap md:px-4">
        {blogData.map((blog, id) => (
          <BlogItem blog={blog} key={id} />
        ))}
      </div>
    </section>
  );
};

export default Blog;
